<template>
  <StepItem
    format="splash"
    @handle-next-step="handleNextStep"
    :is-ready-for-next-step="true"
    :title="`Welcome aboard, ${accountStore.user?.firstName}!`"
    subtitle="Get ready for an epic journey of matching, connecting, and soaring to new heights in your career."
  >
    <AnimationConfetti />
    <template v-slot:next-step-text> Explore Dashboard </template>
    <template v-slot:splash-image>
      <AnimationCelebrate/>
    </template>
  </StepItem>
</template>

<script setup>
import StepItem from "./StepItem.vue";
import { useRouter } from "vue-router";
import AnimationConfetti from "./AnimationConfetti.vue";
import AnimationCelebrate from "./AnimationCelebrate.vue";
import {useAccountStore} from "../stores/AccountStore.js";

const router = useRouter();
const accountStore = useAccountStore();

const handleNextStep = () => router.push({ path: "/dashboard" });
</script>
